import axiosInstance from '../RestClient';

const BASE_URI = '/googleCalendar';

class GoogleCalendarService {
	async getAuthUrl() {
		const uri = `${BASE_URI}/auth-url`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async getStatus({ verifyAppCalendar } = {}) {
		const uri = verifyAppCalendar ? `${BASE_URI}/status?verifyAppCalendar=true` : `${BASE_URI}/status`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async disconnect() {
		const uri = `${BASE_URI}/disconnect`;
		const response = await axiosInstance.post(uri);
		return response;
	}

	async listCalendars() {
		const uri = `${BASE_URI}/calendars`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async setSelectedCalendar(calendarId) {
		const uri = `${BASE_URI}/selected-calendar`;
		const response = await axiosInstance.put(uri, { calendarId });
		return response;
	}

	async listEvents(query) {
		const uri = `${BASE_URI}/events?${query}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async createEvent(payload) {
		const uri = `${BASE_URI}/events`;
		const response = await axiosInstance.post(uri, payload);
		return response;
	}

	async updateEvent(eventId, payload) {
		const uri = `${BASE_URI}/events/${eventId}`;
		const response = await axiosInstance.put(uri, payload);
		return response;
	}

	async deleteEvent(eventId, calendarId) {
		const query = new URLSearchParams();
		if (calendarId) query.set('calendarId', calendarId);
		const uri = `${BASE_URI}/events/${eventId}?${query.toString()}`;
		const response = await axiosInstance.delete(uri);
		return response;
	}

	async updateSyncSettings(payload) {
		const uri = `${BASE_URI}/sync-settings`;
		const response = await axiosInstance.put(uri, payload);
		return response;
	}

	async syncNow(payload) {
		const uri = `${BASE_URI}/sync`;
		const response = await axiosInstance.post(uri, payload);
		return response;
	}
}

export default new GoogleCalendarService();
